/**
 * 화면 위쪽에 붙는 고정 줄(앱 머리줄·폼 단계 막대·섹션 탭) 아래로 요소를 스크롤한다 — 줄 높이는 화면에서 잰다(하드코딩 없음).
 *
 * `scrollIntoView({ block: 'start' })` 는 sticky 머리줄을 모른다 — 폼 단계를 옮기면 새 단계 제목이 머리줄·단계 막대 뒤에 가려졌다
 * (2026-10-07 채용 등록: 폰 390 질문 top 24 < 머리줄+단계 막대 끝 101, PC "근무 조건" top 24 < 머리줄 끝 124).
 */

/** 고정 줄 아래 띄울 간격 */
const DEFAULT_GAP_PX: number = 12;

/**
 * target 과 가로로 겹치는, 화면 위쪽에 붙는 sticky·fixed 줄들이 붙었을 때의 아래 끝(px, 화면 기준).
 * sticky 는 지금 붙어 있지 않아도(아직 문서 흐름 안에 있어도) 붙을 자리(top + 높이)로 센다. 화면 위 1/3 아래에 붙는 줄(하단 버튼 줄 등)·
 * 화면 높이의 1/3 이 넘는 큰 판(서랍 메뉴·옆 칸)·시트 안 요소는 뺀다.
 */
export const stickyTopInset = (target: Element): number => {
    const targetRect: DOMRect = target.getBoundingClientRect();
    const limit: number = window.innerHeight / 3;
    let inset: number = 0;
    document.body.querySelectorAll<HTMLElement>('*').forEach((el: HTMLElement) => {
        const style: CSSStyleDeclaration = window.getComputedStyle(el);
        if (style.position !== 'sticky' && style.position !== 'fixed') return;
        if (style.top === 'auto' || style.visibility === 'hidden' || style.display === 'none') return;
        if (el.contains(target) || el.closest('[role="dialog"]')) return;
        const rect: DOMRect = el.getBoundingClientRect();
        if (rect.height <= 0 || rect.height > limit) return;
        if (rect.right <= targetRect.left || rect.left >= targetRect.right) return;
        const top: number = style.position === 'sticky' ? parseFloat(style.top) || 0 : rect.top;
        if (top > limit) return;
        inset = Math.max(inset, top + rect.height);
    });
    return inset;
};

/** 요소 윗변이 고정 줄 바로 아래(gap 만큼 띄움)에 오게 문서를 스크롤한다 */
export const scrollBelowStickyBars = (target: Element, options?: { behavior?: ScrollBehavior; gap?: number }): void => {
    const gap: number = options?.gap ?? DEFAULT_GAP_PX;
    const top: number = target.getBoundingClientRect().top + window.scrollY - stickyTopInset(target) - gap;
    window.scrollTo({ top: Math.max(0, top), left: 0, behavior: options?.behavior ?? 'auto' });
};
